(() => {
  const TECHNICAL = String(window.CycloOutletWhatsAppAssets?.technical || '573134400963').replace(/\D/g, '') || '573134400963';
  const COMMERCIAL = String(window.CycloOutletWhatsAppAssets?.number || '573142533532').replace(/\D/g, '') || '573142533532';

  const replacePhone = (href, number) => {
    if (!href) return href;
    try {
      const url = new URL(href, window.location.origin);
      if (url.hostname === 'wa.me') {
        const parts = url.pathname.split('/').filter(Boolean);
        if (parts.length) parts[0] = number;
        else parts.push(number);
        url.pathname = '/' + parts.join('/');
        return url.toString();
      }
      if (url.hostname === 'api.whatsapp.com') {
        url.searchParams.set('phone', number);
        return url.toString();
      }
    } catch (_) {}
    return href
      .replace(/(wa\.me\/)(\d+)/i, '$1' + number)
      .replace(/([?&]phone=)(\d+)/i, '$1' + number);
  };

  const routeLink = link => {
    if (!(link instanceof HTMLAnchorElement)) return;
    const href = link.getAttribute('href') || '';
    if (!/wa\.me|api\.whatsapp\.com/i.test(href)) return;

    const decoded = (() => { try { return decodeURIComponent(href.replace(/\+/g, ' ')); } catch (_) { return href; } })();
    const text = `${link.textContent || ''} ${decoded}`;
    const felipeImage = !!link.querySelector('img[src*="advisor-felipe"]');
    const andreaImage = !!link.querySelector('img[src*="advisor-andrea"]');
    const explicitTechnical =
      felipeImage ||
      /\bFelipe\b/i.test(text) ||
      link.matches('[data-co-advisor="felipe"], [data-compat-advisor], .co-compatibility-advisor, .co-v127-sticky__help');
    const explicitCommercial = andreaImage || /\bAndrea\b/i.test(text);

    const desired = explicitTechnical ? TECHNICAL : explicitCommercial ? COMMERCIAL : '';
    if (!desired) return;

    const next = replacePhone(href, desired);
    if (next && next !== href) link.setAttribute('href', next);
  };

  const routeAll = root => {
    if (root instanceof HTMLAnchorElement) routeLink(root);
    root?.querySelectorAll?.('a[href*="wa.me"], a[href*="api.whatsapp.com"]').forEach(routeLink);
  };

  const routeComposedEvent = event => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    const link = path.find(node => node instanceof HTMLAnchorElement && /wa\.me|api\.whatsapp\.com/i.test(node.getAttribute('href') || ''));
    if (link) routeLink(link);
  };

  const init = () => {
    routeAll(document);
    document.addEventListener('pointerdown', routeComposedEvent, true);
    document.addEventListener('click', routeComposedEvent, true);
    if (!document.body || !('MutationObserver' in window)) return;
    new MutationObserver(mutations => {
      mutations.forEach(m => {
        if (m.type === 'attributes' && m.target instanceof HTMLAnchorElement) {
          routeLink(m.target);
          return;
        }
        m.addedNodes.forEach(node => {
          if (node instanceof Element) routeAll(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    window.addEventListener('load', () => routeAll(document), { once: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();